<template>
  <div class="component">
    <header v-bind:class="{ 'is-active': $parent.layout === 'results' }">
      <h5 class="compass">{{ results.length }} results found</h5>
      <h5
        class="shop-online"
        v-if="$parent.filter && $parent.layout === 'results'"
      >
        <a
          v-on:click.capture="
            $root.datalayer.push({
              event: $parent.gtm.event,
              action: 'Shop online',
              location: undefined,
            })
          "
          href="/sleep-apnea/buy-cpap-supplies-online/"
          >Shop online</a
        >
      </h5>
    </header>

    <div class="items" v-if="results.length" ref="items">
      <div
        class="item"
        v-for="item in results"
        v-bind:ref="item.store_code"
        v-bind:key="item.store_code"
        v-on:click="active(item)"
        v-bind:class="{
          'is-active': $parent.marker.active === item.store_code,
        }"
      >
        <div class="meta">
          <h4>{{ item.name }}</h4>
          <p v-if="item.appointment">By appointment only</p>
          <a
            v-on:click.capture="
              $root.datalayer.push({
                event: $parent.gtm.event,
                action: 'Call',
                location: item.name,
              })
            "
            v-bind:href="`tel:${item.phone}`"
            >{{ item.phone | format }}</a
          >
        </div>
        <div class="meta">
          <a class="details" href="#" v-on:click.prevent="details(item)"
            >details</a
          >
          <a
            class="distance"
            v-on:click.capture="
              $root.datalayer.push({
                event: $parent.gtm.event,
                action: 'Directions',
                location: item.name,
              })
            "
            target="_blank"
            v-bind:href="`https://www.google.com/maps?daddr=${item.location.full}`"
            >{{ parseFloat(item.distance).toFixed(1) }} mi</a
          >
        </div>
      </div>

      <div class="extend-miles">
        <a
          v-if="$parent.radius <= 500"
          href="#"
          v-on:click.prevent="$parent.radius += 50"
          class="btn cta-plain text-red icon move-expand"
          >Next 50 miles</a
        >
      </div>

      <!-- supplies-online -->
      <supplies-online v-if="$parent.filter"></supplies-online>
    </div>
  </div>
</template>

<script>
import suppliesOnline from "../shared-support/supplies-online";
import scroll from "../../mixins/scroll";

export default {
  name: "results",
  props: {
    results: {
      type: Array,
    },
  },
  components: {
    suppliesOnline,
  },
  mixins: [scroll],
  watch: {
    "$parent.marker"(val) {
      if (typeof this.$refs[val.active][0] === "undefined") {
        return;
      }
      anime({
        targets: this.$refs.items,
        scrollTop: this.$refs[val.active][0].offsetTop,
        duration: 400,
        easing: "easeOutExpo",
      });
    },
  },
  filters: {
    format(value) {
      return value
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    },
  },
  methods: {
    active(item) {
      this.$parent.marker = Object.assign({}, this.$parent.marker, {
        active: item.store_code,
        store: item,
      });

      if (["xs", "sm", "md"].includes(this.$root.mode)) {
        this.scroll({ to: "html" });
      }

      // this.$root.datalayer.push({
      //     event: this.$parent.gtm.event,
      //     location: item.name,
      //     action: 'Dealer Location Click'
      // });
    },
    details(item) {
      this.active(item);

      this.$nextTick(() => {
        this.$parent.details.active = true;
        this.$parent.details.item = item;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component {
  border-right: 1px solid $cc-resmed-grey-15;
  border-left: 1px solid $cc-resmed-grey-15;

  header {
    padding: 1.5rem;
    border-top: 1px solid $cc-resmed-grey-15;
    border-bottom: 1px solid $cc-resmed-grey-15;
    display: flex;

    > * {
      opacity: 0.4;
    }

    &.is-active {
      margin: 0;

      > * {
        opacity: 1;
      }
    }

    h5 {
      font-size: 0.875rem;
      padding-left: 1.875rem;
      margin: 0;
      flex-grow: 1;

      background-repeat: no-repeat;
      background-size: 1.25rem 1.25rem;
      background-position: left center;

      &.compass {
        background-image: url(#{$assets}/images/icon-compass-black.svg);
        width: 60%;
      }

      &.shop-online {
        background-image: url(#{$assets}/images/icon-shopping-cart-red.svg);
        flex-grow: 0;

        a {
          color: $cc-resmed-action-red;
        }
      }
    }
  }

  .items {
    overflow: auto;
    position: relative;
    padding-bottom: 2rem;
    max-height: 524px;

    .item {
      display: flex;
      align-items: center;
      padding: 1.25rem 1.5rem;
      cursor: pointer;

      &:hover {
        background-color: rgba($cc-resmed-grey-15, 0.3);
      }

      &.is-active {
        background-color: rgba($cc-resmed-grey-15, 0.6);
      }

      .meta {
        a {
          @extend %body-small;
          display: inline-block;
        }

        &:nth-child(1) {
          width: 60%;

          @media (min-width: 768px) and (max-width: 991px) {
            width: 70%;
          }

          h4 {
            margin-bottom: 0.25rem;

            @media (min-width: 768px) {
              font-size: 1.125rem;
            }

            + p {
              @extend %body-small-bold;
              font-style: italic;
            }
          }

          a {
            color: $cc-resmed-action-red;
            padding-left: 2rem;

            text-align: center;
            background-repeat: no-repeat;
            background-size: 1.125rem 1.125rem;
            background-position: left center;
            background-image: url(#{$assets}/images/icon-phone-red.png);
          }
        }
        &:nth-child(2) {
          width: 40%;
          display: flex;
          align-items: center;

          @media (min-width: 768px) and (max-width: 991px) {
            width: 30%;
          }

          a {
            display: block;
            width: 50%;

            padding-top: 2rem;
            margin: 0 auto;
            color: $cc-resmed-black;
            text-decoration: underline;

            text-align: center;
            background-repeat: no-repeat;
            background-size: 1.325rem 1.325rem;
            background-position: center top;

            &.details {
              background-image: url(#{$assets}/images/icon-information-black.svg);
            }

            &.distance {
              background-image: url(#{$assets}/images/icon-directions-black.svg);
            }
          }
        }
      }
    }
  }

  .extend-miles {
    text-align: center;
    padding: 1.25rem;
    margin: 0 0 1.5rem 0;
    border-top: 1px solid $cc-resmed-grey-15;
    border-bottom: 1px solid $cc-resmed-grey-15;
  }
}
</style>

